// Copyright (c) 2015, Alphamonak Solutions

// provide a namespace
if (!window.melon) window.melon = {};

melon.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

melon.provide("locals");
melon.provide("melon.flags");
melon.provide("melon.settings");
melon.provide("melon.utils");
melon.provide("melon.ui.form");
melon.provide("melon.modules");
melon.provide("melon.templates");
melon.provide("melon.test_data");
melon.provide("melon.utils");
melon.provide("melon.model");
melon.provide("melon.user");
melon.provide("melon.session");
melon.provide("melon._messages");
melon.provide("locals.DocType");

// for listviews
melon.provide("melon.listview_settings");
melon.provide("melon.tour");
melon.provide("melon.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
